/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_LabelInputs */

const en_landing_showcase_label = /** @type {(inputs: Landing_Showcase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product label`)
};

const zh_landing_showcase_label = /** @type {(inputs: Landing_Showcase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品标签`)
};

/**
* | output |
* | --- |
* | "Product label" |
*
* @param {Landing_Showcase_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_label = /** @type {((inputs?: Landing_Showcase_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_label(inputs)
	return zh_landing_showcase_label(inputs)
});
export { landing_showcase_label as "landing.showcase.label" }